var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.$apollo.loading,"search":_vm.search,"hide-default-footer":_vm.hideFooter},scopedSlots:_vm._u([{key:"item.validFrom",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("formatDate")(item.validFrom)))]}},{key:"item.validTo",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("formatDate")(item.validTo)))]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('default-list-actions',{attrs:{"item":item,"hide-view":true},on:{"deleteItem":function($event){return _vm.deleteItem($event)},"editItem":function($event){return _vm.editItem($event)}}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a58fe492","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/suppliers/taxes/TaxesTable.vue
// module id = null
// module chunks = 